module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-wink-fill-8f36dcea.svg";